import { gql } from '@apollo/client';
import { FieldFragment } from 'graphql/Field/fragments/FieldFragment';
import { LanguageFragment } from 'graphql/Language/fragments/LanguageFragment';
import { SaleItemFileFragment } from 'graphql/SaleItemFile/fragments/SaleItemFileFragment';
import { SaleItemGroupFragment } from 'graphql/SaleItemGroup/fragments/SaleItemGroupFragment';
import { SaleItemImageFragment } from 'graphql/SaleItemImage/fragments/SaleItemImageFragment';
import { TaxFragment } from 'graphql/Tax/fragments/TaxFragment';
/**
 * @fragment DealItemSaleItemOptionFragment
 * @since 1.0.0
 */
export const DealItemSaleItemOptionFragment = gql `
  fragment DealItemSaleItemOptionFragment on SaleItem {
    id
    sku
    price
    cost
    inventory
    category
    configuration
    optionConfiguration
    active
    promoted
    exclusiveTimeSlot
    exclusive
    taxable
    unitOfMeasurement
    quantityCalculation
    title
    infos
    summary
    deletedAt

    relations {
      id
      type
      quantity
      saleItemId
      saleItem {
        id
        sku
        title
        active
      }
      relatedSaleItem {
        id
        sku
        title
        active
        price
      }
    }

    group {
      ...SaleItemGroupFragment
    }

    groups {
      id
      title
      display
      hasUniqueOptionRestriction
      mustHaveOptionSelected
    }

    taxes {
      ...TaxFragment
    }

    image {
      ...SaleItemImageFragment
    }

    images {
      ...SaleItemImageFragment
    }

    files {
      ...SaleItemFileFragment
    }

    translations {
      id
      title
      infos
      summary
      createdAt
      updatedAt

      language {
        ...LanguageFragment
      }
    }

    fieldValues {
      value
      field {
        id
        name
        title
        infos
        type
        visibility
        promote
        group {
          id
          category
        }
      }
    }
  }

  ${SaleItemGroupFragment}
  ${SaleItemFileFragment}
  ${LanguageFragment}
  ${SaleItemImageFragment}
  ${FieldFragment}
  ${TaxFragment}
`;
